export default __webpack_public_path__ + "static/orange_frog_desktop-2895cfebef628e287832341baa11788a.png";